import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AppRoute from './AppRoute';
import { WebSiteLayout } from '../layouts/Website/WebSiteLayout';
import Home from '../views/website/home';

//AUTH
import SelectUserType from '../views/auth/selectUserType';
import PersonSignUp from '../views/auth/signUp_person';
import SignIn from '../views/auth/signIn';
import ForgotPassword from '../views/auth/forgotPassword';

import { WebSiteLayout2 } from '../layouts/Website/WebsiteLayout2';
import Merchants from '../views/website/merchants';
import MerchantMenu from '../views/website/merchants/menu';
import MerchantProfile from '../views/website/merchants/profile';
import MerchantMenuProducts from '../views/website/merchants/menuProducts';
import MerchantSelect from '../views/website/merchants/select';
import CompanySignUp from '../views/auth/signUp_company';
import BusinessCard from '../views/website/merchants/businessCard';
import EmailVerification from '../views/auth/emailVerification';
import Privacy from '../views/legal/privacy';
import TermsAndConditions from '../views/legal/terms';
import DeleteUser from '../views/legal/deleteUser';
import Events from '../views/website/events';
import EventsDetails from '../views/website/events/detail';
import EventsTickets from '../views/website/events/tickets';
import EventsGastromedia from '../views/website/events/gastromedia';
import GastromediaAlly from '../views/website/allies/gastromedia';
import Hamburger from '../views/website/allies/tastyFest/hamburger';
import Usm from '../views/website/allies/usm';
import CompleteProfile from '../views/auth/CompleteProfile';
import { HomeLayout } from '../layouts/Website/home/HomeLayout';
import Search from '../views/website/search';
import TransportBooking from '../views/website/transporte/Booking';
import TransportBooking2 from '../views/website/transporte/Booking2';
import Ticket from '../views/client/events/ticket';
import ForBusiness from '../views/website/ForBusiness';
import ForPeople from '../views/website/forPeople';
import MamaAzul from '../views/website/allies/mamaazul';
import JorgeSilvaCook from '../views/website/allies/exitart/JorgeSilva';
import SimpleLayout from '../layouts/simple';
import TeGustaElChisme from '../views/website/allies/tegustaelchisme';
import { EventsLayout } from '../layouts/Website/events/EventsLayout';
import FreeCoupon from '../views/website/merchants/freeCoupon';
import BoxPark from '../views/website/allies/boxpark';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import ReactGA from "react-ga4";
import { usePageTracking } from '../hooks/usePageTracking';
import PrintQR from '../views/website/Print';
import UploadFile from '../views/website/UploadFile';
import EventsReview from '../views/website/events/review';
import MerchantReview from '../views/website/merchants/review';
import Digitel from '../views/website/allies/digitel';
import { NeutralLayout } from '../layouts/Website/NeutralLayout';
import DigitelSorteo from '../views/website/allies/digitel/sorteo';
import MerchantServices from '../views/website/MerchantServices';
import EventsReviewFeriaTurismo from '../views/website/events/feriaTurismo';
import BusinessCardV2 from '../views/website/merchants/BusinessCardV2';
import EventTickets from '../views/website/events/EventTickets';
import PublicMerchantProfile from '../views/website/merchants/PublicMerchantProfile';
import HelpRequestPublicView from '../views/website/help/HelpRequestPublicView';
import HelpTransparencyView from '../views/website/help/HelpTransparencyView';
import HelpRequestsDashboardView from '../views/company/help/HelpRequestsDashboardView';
import HelpLayout from '../layouts/help/HelpLayout';
import ChangePassword from '../views/auth/changePassword';
import DispatchControlView from '../views/company/help/DispatchControlView';
import DispatchCreateView from '../views/company/help/DispatchCreateView';



export default function HelpNavigation()
{
    usePageTracking()
    
    return(
        <Switch>
            <AppRoute exact path='/' layout={HelpLayout} component={HelpRequestsDashboardView} />
            
            {/**HELP HELP HELP */}
            <AppRoute exact path='/help' layout={HelpLayout} component={HelpRequestsDashboardView} />

            <AppRoute exact path='/dispatches' layout={HelpLayout} component={DispatchControlView} />
            <AppRoute exact path='/dispatches/create' layout={HelpLayout} component={DispatchCreateView} />

            <AppRoute exact path='/sos-solicitud' layout={HelpLayout} component={HelpRequestPublicView} />
            <AppRoute exact path='/sos-transparencia' layout={HelpLayout} component={HelpTransparencyView} />
            <AppRoute exact path='/seguridad' layout={HelpLayout} component={ChangePassword} />


            {/**Para las rutas no encontradas */}
            <Route path="*">
                <Redirect  to="/"/>
            </Route>
        </Switch>
    )
}
